module.exports = __webpack_public_path__ + "img/a4.a0f12b46.jpg";